import React, { Component } from "react";
import MetisMenu from "metismenujs";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { withNamespaces } from 'react-i18next';


const sidebarDictionary = {
    "/dashboard-special": "/dashboard",
    "/dashboard": "/dashboard",
    "/dashboard-old": "/dashboard-old",
    "/configurations": "/configurations",
    "/permissions": "/permissions",
    "/members-list": "/members-list",
    "/members-list-new": "/members-list-new",
    "/member-overview": "/members-list",
    "/member-add": "/member-add",
    "/member-add-new": "/member-add-new",
    "/members-verified": "/members-verified",
    "/members-verified-new": "/members-verified-new",
    "/individual-overview": "/members-list",
    "/tasks": "/tasks",
    "/tasks/qr": "/tasks/qr",
    "/tasks-received": "/tasks",
    "/task-qr-list": "/tasks/qr",
    "/news-grid": "/news-grid",
    "/notifications": "/notifications",
    "/patronage-main": "/patronage-main",
    "/patronage-referred": "/patronage-referred",
    "/patronage-individual": "/patronage-individual",
    "/patronager": "/patronager",
    "/patronager-new": "/patronager-new",
    "/patronager-add": "/patronager",
    "/my-patronage": "/my-patronage",
    "/diaspora-references": "/diaspora-references",
    "/patronage-details": "/patronage-details",
    "/pages-comingsoon": "/dashboard",
    "/observer-module": "/observer-module",
    "/patronager-module": "/patronager-module",
    "/my-vhp-voters": "/my-vhp-voters",
    "/emigrant": "/emigrant"
}


// const isPatronager = useSelector((state) => state.Member.is_patronager);
// election-day, election-objectives, election-results, exit-poll, article-list, 
// article-add, social-stats, social-config  map-search,  actions, homework, perception, predictions


class SidebarContent extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.initMenu();
        }
    }


    initMenu() {
        new MetisMenu("#side-menu");

        var matchingMenuItem = null;
        var ul = document.getElementById("side-menu");
        var items = ul.getElementsByTagName("a"); // items is an HTMLCollection object; a weird dictionary type with 0,1,... as keys
        var items_arr = Array.prototype.slice.call(items); // convert it to an array to get rid of that nonsense and enable us to apply the filter method to it

        // a \
        // b - d
        // c /

        var found = null;

        if (
            this.props.location.pathname &&
            sidebarDictionary[this.props.location.pathname]
        ) {
            found = items_arr.filter((el) => {
                return el.href.includes(
                    sidebarDictionary[this.props.location.pathname]
                );
            });
        }

        if (found && found.length > 0) {
            this.activateParentDropdown(found[0]);
            return;
        }

        for (var i = 0; i < items.length; ++i) {
            if (
                this.props.location.pathname ===
                items[i].href.slice(items[i].href.lastIndexOf("#") + 1) &&
                this.props.location.pathname !== "/pages-comingsoon"
            ) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown = (item) => {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");
                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;

                    if (parent4) {
                        parent4.classList.add("mm-show");
                        const parent5 = parent4.parentElement;

                        if (parent5) {
                            parent5.classList.add("mm-active");
                            parent5.childNodes[0].classList.add("mm-active"); //a
                            const parent6 = parent5.parentElement;

                            if (parent6) {
                                parent6.classList.add("mm-show");
                            }
                        }
                    }
                }
            }

            return false;
        }

        return false;
    };

    // re-architect this:
    // Render only the ones you have permission for
    // when it's time to render:
    // have a dictionary of some sort where you tell it how to render each one.
    // like a massive switch statement?? Multi-level Dictionary???
    render() {

        const permissions_dict = this.props.permissions;
        // const high_division = this.props.high_division;
        const is_patronager = this.props.is_patronager;
        const is_observer = this.props.is_observer;
        const is_diaspora_coordinator = this.props.is_diaspora_coordinator;
        const is_ftv_coordinator = this.props.is_ftv_coordinator;


        return (
            <React.Fragment>
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Sistemi</li>


                        {/* 1. DASHBOARD */}
                        <li>
                            <Link to="/dashboard" key="1">
                                <i className="material-icons">dashboard</i>
                                <span>Dashboard</span>
                            </Link>
                        </li>


                        {/* 2. DETYRA */}
                        {permissions_dict["Detyra"] && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect" key="26">
                                    <i className="material-icons">work_outline</i>
                                    <span>Detyra</span>
                                </Link>
                                <ul className="sub-menu" aria-expanded="false">

                                    {permissions_dict["DetyratMarra"] && (
                                        <li>
                                            <Link to="/tasks" key="28">
                                                <i className="material-icons">assignment_returned</i>
                                                Detyrat e Marra
                                            </Link>
                                        </li>
                                    )}

                                    <li>
                                        <Link to="/tasks/qr" key="29">
                                            <i className="material-icons">qr_code_scanner</i>
                                            Skanimi QR
                                        </Link>
                                    </li>

                                </ul>
                            </li>
                        )}


                        {/* 3. TE REFERUARIT */}
                        {/* {is_patronager && ( */}
                        <li>
                            <Link to="/patronage-referred" key="14">
                                <i className="material-icons">record_voice_over</i>
                                <span>Të referuarit</span>
                            </Link>
                        </li>
                        {/* )} */}

                        {/* {permissions_dict['references_emigrants'] && ( */}
                        <li>
                            <Link to="/emigrant" key="34">
                                <i className="material-icons">assignment_ind</i>
                                <span>Emigrantët</span>
                            </Link>
                        </li>
                        {/* )} */}

                        {is_diaspora_coordinator && (
                            <li>
                                <Link to="/#" className="has-arrow waves-effect" key="266">
                                    <i className="material-icons">public</i>
                                    <span>Diaspora</span>
                                </Link>
                                <ul className="sub-menu" aria-expanded="false">
                                    <li>
                                        <Link to="diaspora-references" key="288">
                                            <i className="material-icons">account_circle</i>
                                            Referencat e mia
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        )}

                        {is_ftv_coordinator && (
                            <li>
                                <Link to="/my-vhp-voters" key="24">
                                    <i className="material-icons">how_to_vote</i>
                                    <span>Votuesit për Herë të Parë</span>
                                </Link>
                            </li>
                        )}

                        {/* 4. TE PATRONAZHUARIT E MI */}
                        {is_patronager && (
                            <li>
                                <Link to="/my-patronage" key="14">
                                    <i className="material-icons">recent_actors</i>
                                    <span>Të patronazhuarit e mi</span>
                                </Link>
                            </li>
                        )}

                        {is_observer && (
                            <li>
                                <Link to="/observer-module" key="54">
                                    <i className="material-icons">remove_red_eye</i>
                                    <span>Dita e Votimit</span>
                                </Link>
                            </li>
                        )}

                        {is_patronager && (
                            <li>
                                <Link to="/patronager-module" key="64">
                                    <i className="material-icons">unarchive</i>
                                    <span>Dita e Votimit</span>
                                </Link>
                            </li>
                        )}

                        {/* 5. LAJME */}
                        <li>
                            <Link to="news-grid" key="85">
                                <i className="material-icons">speaker_notes</i>
                                <span>Lajme</span>
                            </Link>
                        </li>

                        {/* 6. NJOFTIME */}
                        <li>
                            <Link to="notifications" key="85">
                                <i className="material-icons">notifications</i><span>Njoftime</span>
                            </Link>
                        </li>

                    </ul>
                </div>
            </React.Fragment >
        );
    }
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout,
        permissions: state.Permission.permissions,
        high_division: state.Member.high_division,
        is_patronager: state.Member.is_patronager,
        is_observer: state.Member.is_observer,
        is_diaspora_coordinator: state.Member.is_diaspora_coordinator,
        is_ftv_coordinator: state.Member.is_ftv_coordinator,
    };
};

export default connect(mapStatetoProps, {})(withRouter(withNamespaces()(SidebarContent)));
// export default withRouter(withNamespaces()(SidebarContent));
